import { Form } from "@redriver/cinnamon-mui";
import { expenseTypesLookup } from "modules/lookups";

const ExpenseTypeDropdown = (props) => (
  <Form.Dropdown lookup={expenseTypesLookup} search {...props} />
);

export default ExpenseTypeDropdown;
